export const routesConfig = {
  home: '/painel/clientes',
  authRoutes: '/acesso',
  userRoutes: '/painel',
  auth: {
    login: '/acesso/entrar'
  },
  activities: {
    calendar: {
      list: '/painel/calendario/contatos'
    }
  },
  customers: {
    customer: {
      list: '/painel/clientes',
      create: '/painel/clientes/cadastro',
      details: `/painel/clientes`
    }
  },
  oportunities: {
    oportunity: {
      list: '/painel/oportunidades',
      create: '/painel/oportunidades/cadastro',
      details: `/painel/oportunidades`,
      edit: `/painel/oportunidades`
    }
  },
  orders: {
    order: {
      list: '/painel/pedidos',
      create: '/painel/pedidos/cadastro',
      details: `/painel/pedidos`,
      edit: `/painel/pedidos`
    }
  },
  ordersOfService: {
    serviceOrder: {
      list: '/painel/ordem-de-servico',
      create: '/painel/ordem-de-servico/cadastro',
      details: `/painel/ordem-de-servico`,
      edit: `/painel/ordem-de-servico`
    }
  },
  contracts: {
    contract: {
      list: '/painel/contratos',
      create: '/painel/contratos/cadastro',
      datails: `/painel/contratos`
    }
  }
}
